/**
 * Admin Info Component
 * Shows admin-specific information and profile
 */

import UserProfile from './UserProfile';

function AdminInfo({ user, onRefresh }) {
    return (
        <div className="max-w-4xl mx-auto p-3 sm:p-6">
            <div className="mb-4 sm:mb-6">
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
                    معلومات المدير
                </h1>
                <p className="text-sm sm:text-base text-gray-600">
                    عرض وإدارة معلومات حساب المدير
                </p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
                <UserProfile user={user} onRefresh={onRefresh} />
            </div>

            <div className="mt-4 sm:mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4 sm:p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-3">
                    صلاحيات المدير
                </h2>
                <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center space-x-2 space-x-reverse">
                        <span className="text-green-500 text-xl">✓</span>
                        <span>إدارة جميع المستخدمين</span>
                    </li>
                    <li className="flex items-center space-x-2 space-x-reverse">
                        <span className="text-green-500 text-xl">✓</span>
                        <span>عرض وإدارة جميع البلاغات</span>
                    </li>
                    <li className="flex items-center space-x-2 space-x-reverse">
                        <span className="text-green-500 text-xl">✓</span>
                        <span>الوصول إلى لوحة التحكم</span>
                    </li>
                    <li className="flex items-center space-x-2 space-x-reverse">
                        <span className="text-green-500 text-xl">✓</span>
                        <span>إدارة إعدادات النظام</span>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default AdminInfo;
